
const INITIAL_STATE = false;

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SKIP_LOADING':
      return action.payload;
    default:
      return state;
  }
}
